import { RadioGroupProps } from "./types"
import React from "react"
import { Radio } from "~widgets/radio"
import { FeildFloatLabel } from "~widgets/feild-float-label"
import styled from '~/ui/styled'

const RadioGroupWrapper = styled.View``

const RadioesArea = styled.View`
  flex-direction: row;
`

const RadioWrapper = styled.View`
  margin-right: 15px;
`

const RadioGroup: React.FC<RadioGroupProps> = ({ label, options, value, setValue }) => {
  return (
    <RadioGroupWrapper>
      {!!label && <FeildFloatLabel>{label}</FeildFloatLabel>}
      <RadioesArea>
        {options.map((option) => {
          return (
            <RadioWrapper key={option.value}>
              <Radio {...option} curValue={value} onClick={setValue} />
            </RadioWrapper>
          )
        })}
      </RadioesArea>
    </RadioGroupWrapper>
  )
}

export default RadioGroup
